import axios from 'axios';
import { setupCache } from 'axios-cache-adapter';
import AppConfig from '../appConfig';
import * as loghelper from '../common/loghelper';
import { getAuthToken } from './authToken';



const cache = setupCache({
    maxAge: 15 * 60 * 60 * 1000,
    exclude: {
        paths: [
            // /Controler\/Action$/,
        ]
    }
});

const api = axios.create({
    adapter: cache.adapter
});

api.interceptors.request.use(request => {
    if (AppConfig.axiosLogger) {
        loghelper.consoleTime('ajax ' + request.method);
    }
    return request;
});

api.interceptors.response.use(response => {
    if (AppConfig.axiosLogger) {
        loghelper.consoleTimeEnd('ajax ' + response.config.method);
    }
    return response;
});

export const getAxios = async (url, axiosRequestConfig) => {
    const headers = {
        userId: localStorage.getItem('userId') ? localStorage.getItem('userId') : AppConfig.env('userId'),
        BrowserSessionId: getCookie('BrowserSessionId'),
    };
    if (AppConfig.auth0.useAuth0) {
        const token = await getAuthToken();
        if (token) headers.Authorization = `Bearer ${token}`;
    }
    url = AppConfig.env('url') + url;
    try {
        return await axios({
            method: 'get',
            url: url,
            headers: headers,
            callTime: axiosRequestConfig.params?.callTime,
        });
    } catch (response) {
        console.log(response);
        throw response;
    }
};

export const postAxios = async (url, axiosRequestConfig) => {
    const headers = {
        userId: localStorage.getItem('userId') ? localStorage.getItem('userId') : AppConfig.env('userId'),
        connectionId: sessionStorage.getItem('tabId') ? sessionStorage.getItem('tabId') : AppConfig.env('connectionId'),
        BrowserSessionId: getCookie('BrowserSessionId'),
        'TimeStart': getUtcDate().getTime(),
        'Url': url,
        'Step': 'DataCall',
        'IsWebService': '0',
        'elapsedTime': 0
    };
    if (AppConfig.auth0.useAuth0) {
        const token = await getAuthToken();
        if (token) headers.Authorization = `Bearer ${token}`;
    }
    url = AppConfig.env('url') + url;
    if (!axiosRequestConfig.params.callTime) {
        axiosRequestConfig.params = { ...axiosRequestConfig.params, callTime: new Date() };
    }
    try {
        return await axios({
            method: 'post',
            url: url,
            data: axiosRequestConfig.params,
            headers: headers,
            callTime: axiosRequestConfig.params.callTime,
        });
    } catch (response) {
        console.log(response);
        throw response;
    }
};

var getUtcDate = function () {
    var dt = new Date();
    return new Date(dt.getUTCFullYear(), dt.getUTCMonth(), dt.getUTCDate(), dt.getUTCHours(), dt.getUTCMinutes(), dt.getUTCSeconds(), dt.getUTCMilliseconds());
};

export const getCookie = (c_name) => {
    if (document.cookie.length > 0) {
        var c_start = document.cookie.indexOf(c_name + "=");
        if (c_start !== -1) {
            c_start = c_start + c_name.length + 1;
            var c_end = document.cookie.indexOf(";", c_start);
            if (c_end === -1) {
                c_end = document.cookie.length;
            }
            return unescape(document.cookie.substring(c_start, c_end));
        }
    }
    return "";
};
